module.exports = __webpack_public_path__ + "img/loading.0df156c2.svg";